import React from "react"
import { filterInputStyle, filterSelectStyle, primaryButtonStyle } from "../styles/commonStyles"
import { highlightText } from "../utils/helpers"
import { TYPOGRAPHY } from "../constants/theme"

const AddPlanModal = ({
	isOpen,
	onClose,
	userSearchQuery,
	setUserSearchQuery,
	foundUsers,
	selectedUser,
	setSelectedUser,
	selectedPlanForUser,
	setSelectedPlanForUser,
	planList,
	isSearchingUsers,
	isAddingPlan,
	hasSearched,
	onSearchUsers,
	onAddPlan,
}) => {
	if (!isOpen) return null

	return (
		<div
			style={{
				position: "fixed",
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				backgroundColor: "rgba(0, 0, 0, 0.5)",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				zIndex: 1000,
			}}
			onClick={(e) => {
				if (e.target === e.currentTarget) {
					onClose()
				}
			}}
		>
			<div
				style={{
					backgroundColor: "white",
					borderRadius: "8px",
					padding: "24px",
					width: "90%",
					maxWidth: "600px",
					maxHeight: "80vh",
					overflow: "auto",
					boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
				}}
			>
				{/* Header */}
				<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
					<h3 style={{ margin: 0, fontSize: TYPOGRAPHY.fontSize.xl, fontWeight: "600" }}>เพิ่มแพ็คเกจหนังสือพิมพ์</h3>
					<button
						onClick={onClose}
						style={{
							background: "none",
							border: "none",
							fontSize: TYPOGRAPHY.fontSize["2xl"],
							cursor: "pointer",
							color: "#666",
							padding: "0",
						}}
					>
						×
					</button>
				</div>

				{/* User Search */}
				<div style={{ marginBottom: "20px" }}>
					<label style={{ display: "block", marginBottom: "8px", fontSize: TYPOGRAPHY.fontSize.sm, fontWeight: "500" }}>ค้นหา</label>
					<div style={{ display: "flex", gap: "8px" }}>
						<input
							type="text"
							placeholder="ค้นหาด้วย ID, Email, หรือเบอร์โทร"
							value={userSearchQuery}
							onChange={(e) => setUserSearchQuery(e.target.value)}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									onSearchUsers(userSearchQuery)
								}
							}}
							style={{
								...filterInputStyle,
								flex: 1,
							}}
						/>
						<button
							onClick={() => onSearchUsers(userSearchQuery)}
							disabled={isSearchingUsers}
							style={{
								...primaryButtonStyle,
								minWidth: "80px",
								opacity: isSearchingUsers ? 0.6 : 1,
							}}
						>
							{isSearchingUsers ? "กำลังค้นหา..." : "ค้นหา"}
						</button>
					</div>
				</div>

				{/* Search Results */}
				{hasSearched && (
					<div style={{ marginBottom: "20px" }}>
						<label style={{ display: "block", marginBottom: "8px", fontSize: TYPOGRAPHY.fontSize.sm, fontWeight: "500" }}>Search Results</label>
						{foundUsers.length > 0 ? (
							<div
								style={{
									border: "1px solid #d1d5db",
									borderRadius: "8px",
									maxHeight: "350px",
									overflowY: "auto",
									backgroundColor: "#fafafa",
								}}
							>
								{foundUsers.map((user, index) => (
									<UserCard
										key={user.memberData.id}
										user={user}
										index={index}
										isSelected={selectedUser?.memberData?.id === user.memberData.id}
										onSelect={() => setSelectedUser(user)}
										searchQuery={userSearchQuery}
									/>
								))}
							</div>
						) : (
							<NoUsersFound searchQuery={userSearchQuery} />
						)}
					</div>
				)}

				{/* Selected User Info */}
				{selectedUser && <SelectedUserInfo user={selectedUser} />}

				{/* Plan Selection */}
				<div style={{ marginBottom: "20px" }}>
					<label style={{ display: "block", marginBottom: "8px", fontSize: TYPOGRAPHY.fontSize.sm, fontWeight: "500" }}>เลือกแพ็คเกจ</label>
					<select
						value={selectedPlanForUser}
						onChange={(e) => setSelectedPlanForUser(e.target.value)}
						style={{
							...filterSelectStyle,
							width: "100%",
						}}
					>
						<option value="">เลือกแพ็คเกจ</option>
						{planList.map((plan) => (
							<option key={plan.id} value={plan.id}>
								{plan.name}
							</option>
						))}
					</select>
				</div>

				{/* Action Buttons */}
				<div style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
					<button
						onClick={onClose}
						style={{
							padding: "10px 20px",
							border: "1px solid #d1d5db",
							borderRadius: "6px",
							backgroundColor: "white",
							color: "#374151",
							cursor: "pointer",
							fontSize: TYPOGRAPHY.fontSize.sm,
						}}
					>
						ยกเลิก
					</button>
					<button
						onClick={onAddPlan}
						disabled={!selectedUser || !selectedPlanForUser || isAddingPlan}
						style={{
							...primaryButtonStyle,
							opacity: !selectedUser || !selectedPlanForUser || isAddingPlan ? 0.6 : 1,
							cursor: !selectedUser || !selectedPlanForUser || isAddingPlan ? "not-allowed" : "pointer",
						}}
					>
						{isAddingPlan ? "กำลังเพิ่มแพ็คเกจ..." : "เพิ่มแพ็คเกจ"}
					</button>
				</div>
			</div>
		</div>
	)
}

// User Card Component
const UserCard = ({ user, index, isSelected, onSelect, searchQuery }) => (
	<div
		onClick={onSelect}
		style={{
			padding: "16px",
			margin: "8px",
			borderRadius: "8px",
			border: "1px solid #e5e7eb",
			backgroundColor: isSelected ? "#dbeafe" : "white",
			cursor: "pointer",
			boxShadow: isSelected ? "0 2px 8px rgba(59, 130, 246, 0.15)" : "0 1px 3px rgba(0, 0, 0, 0.1)",
			position: "relative",
		}}
	>
		{/* หมายเลขลำดับ */}
		<div
			style={{
				position: "absolute",
				top: "8px",
				right: "12px",
				backgroundColor: isSelected ? "#3b82f6" : "#6b7280",
				color: "white",
				borderRadius: "50%",
				width: "24px",
				height: "24px",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				fontSize: TYPOGRAPHY.fontSize.sm,
				fontWeight: "600",
			}}
		>
			{index + 1}
		</div>

		{/* Member Data */}
		<div style={{ marginBottom: "12px", paddingRight: "36px" }}>
			<div
				style={{
					fontWeight: "700",
					fontSize: TYPOGRAPHY.fontSize.md,
					color: "#1f2937",
					marginBottom: "6px",
					display: "flex",
					alignItems: "center",
					gap: "8px",
				}}
			>
				<span role="img" aria-label="person">
					👤
				</span>
				<span
					style={{
						backgroundColor: "#f3f4f6",
						padding: "4px 8px",
						borderRadius: "12px",
						fontSize: TYPOGRAPHY.fontSize.sm,
						fontWeight: "600",
					}}
				>
					สมาชิกไทยรัฐ (Thairath Member)
				</span>
			</div>
			<div style={{ fontSize: TYPOGRAPHY.fontSize.sm, fontWeight: "600", marginLeft: "32px", color: "#374151" }}>
				{highlightText(user.memberData?.name || "ไม่มีชื่อ", searchQuery)}
			</div>
			<div style={{ fontSize: TYPOGRAPHY.fontSize.sm, color: "#6b7280", marginLeft: "32px", marginTop: "2px" }}>
				Member ID: {highlightText(user.memberData.id, searchQuery)}
			</div>
			<div
				style={{
					fontSize: TYPOGRAPHY.fontSize.sm,
					color: "#6b7280",
					marginTop: "4px",
					marginLeft: "32px",
					display: "flex",
					alignItems: "center",
				}}
			>
				<span role="img" aria-label="email">
					📧
				</span>
				&nbsp;&nbsp;
				{highlightText(user.memberData?.email || user.memberData?.msisdn || "ไม่มีข้อมูลติดต่อ", searchQuery)}
			</div>
		</div>

		{/* Customer Data */}
		{user.customerData ? <CustomerDataSection customerData={user.customerData} searchQuery={searchQuery} /> : <NoCustomerDataSection />}
	</div>
)

// Customer Data Section
const CustomerDataSection = ({ customerData, searchQuery }) => (
	<div
		style={{
			marginTop: "12px",
			paddingTop: "12px",
			paddingRight: "36px",
			borderTop: "2px solid #e5e7eb",
			backgroundColor: "#f8fffe",
			borderRadius: "6px",
			padding: "12px",
			margin: "0 -4px",
		}}
	>
		<div
			style={{
				fontWeight: "700",
				fontSize: TYPOGRAPHY.fontSize.md,
				color: "#059669",
				marginBottom: "6px",
				display: "flex",
				alignItems: "center",
				gap: "8px",
			}}
		>
			<span role="img" aria-label="newspaper">
				📰
			</span>
			<span
				style={{
					padding: "4px 8px",
					borderRadius: "12px",
					fontSize: TYPOGRAPHY.fontSize.sm,
					fontWeight: "600",
					color: "#059669",
				}}
			>
				สมาชิกหนังสือพิมพ์
			</span>
		</div>
		<div style={{ fontSize: TYPOGRAPHY.fontSize.sm, fontWeight: "600", marginLeft: "32px", color: "#374151" }}>
			{highlightText(customerData?.customerInfo?.name || "ไม่มีชื่อ", searchQuery)}
		</div>
		<div style={{ fontSize: TYPOGRAPHY.fontSize.sm, color: "#6b7280", marginLeft: "32px", marginTop: "2px" }}>
			Customer ID: {highlightText(customerData.id, searchQuery)} (
			{highlightText(customerData?.customerInfo?.email || customerData?.customerInfo?.phoneNumber || "", searchQuery)})
		</div>
		{customerData?.latestPlan && (
			<div
				style={{
					fontSize: TYPOGRAPHY.fontSize.sm,
					color: "#059669",
					marginTop: "6px",
					marginLeft: "32px",
					fontWeight: "600",
					display: "flex",
					alignItems: "center",
					gap: "6px",
					padding: "6px 8px",
					borderRadius: "6px",
					width: "fit-content",
				}}
			>
				<span role="img" aria-label="plan">
					🎫
				</span>
				แพ็คเกจล่าสุด: {customerData.latestPlan.title}
			</div>
		)}
	</div>
)

// No Customer Data Section
const NoCustomerDataSection = () => (
	<div
		style={{
			marginTop: "12px",
			paddingTop: "12px",
			paddingRight: "36px",
			borderTop: "2px solid #e5e7eb",
			backgroundColor: "#fafafa",
			borderRadius: "6px",
			padding: "12px",
			margin: "0 -4px",
		}}
	>
		<div
			style={{
				fontSize: TYPOGRAPHY.fontSize.sm,
				color: "#9ca3af",
				fontStyle: "italic",
				marginLeft: "32px",
				display: "flex",
				alignItems: "center",
				gap: "8px",
			}}
		>
			<span role="img" aria-label="newspaper">
				📰
			</span>
			<span
				style={{
					backgroundColor: "#e5e7eb",
					padding: "4px 8px",
					borderRadius: "12px",
					fontSize: TYPOGRAPHY.fontSize.sm,
					fontWeight: "500",
				}}
			>
				ยังไม่เป็นสมาชิกหนังสือพิมพ์
			</span>
		</div>
	</div>
)

// No Users Found Component
const NoUsersFound = ({ searchQuery }) => (
	<div
		style={{
			border: "1px solid #d1d5db",
			borderRadius: "8px",
			padding: "32px",
			textAlign: "center",
			backgroundColor: "#fafafa",
		}}
	>
		<div style={{ fontSize: TYPOGRAPHY.fontSize.lg, color: "#6b7280", marginBottom: "8px" }}>
			<span role="img" aria-label="search" style={{ fontSize: TYPOGRAPHY.fontSize["3xl"], marginBottom: "8px", display: "block" }}>
				🔍
			</span>
			ไม่พบผู้ใช้
		</div>
		<div style={{ fontSize: TYPOGRAPHY.fontSize.sm, color: "#9ca3af" }}>ไม่พบผู้ใช้ที่ตรงกับคำค้นหา "{searchQuery}"</div>
		<div style={{ fontSize: TYPOGRAPHY.fontSize.sm, color: "#9ca3af", marginTop: "8px" }}>ลองค้นหาด้วย ID, Email หรือเบอร์โทรใหม่อีกครั้ง</div>
	</div>
)

// Selected User Info Component
const SelectedUserInfo = ({ user }) => (
	<div style={{ marginBottom: "20px" }}>
		<label style={{ display: "block", marginBottom: "8px", fontSize: TYPOGRAPHY.fontSize.sm, fontWeight: "500" }}>Selected User</label>
		<div
			style={{
				border: "1px solid #0284c7",
				borderRadius: "8px",
				backgroundColor: "#f0f9ff",
				padding: "16px",
				boxShadow: "0 2px 8px rgba(2, 132, 199, 0.15)",
				position: "relative",
			}}
		>
			{/* Selected indicator */}
			<div
				style={{
					position: "absolute",
					top: "8px",
					right: "12px",
					backgroundColor: "#10b981",
					color: "white",
					borderRadius: "12px",
					padding: "4px 8px",
					fontSize: TYPOGRAPHY.fontSize.xs,
					fontWeight: "600",
				}}
			>
				เลือกแล้ว
			</div>

			{/* Member Data */}
			<div style={{ marginBottom: "12px", paddingRight: "80px" }}>
				<div
					style={{
						fontWeight: "700",
						fontSize: TYPOGRAPHY.fontSize.md,
						color: "#1f2937",
						marginBottom: "6px",
						display: "flex",
						alignItems: "center",
						gap: "8px",
					}}
				>
					<span role="img" aria-label="person">
						👤
					</span>
					<span
						style={{
							backgroundColor: "#f3f4f6",
							padding: "4px 8px",
							borderRadius: "12px",
							fontSize: TYPOGRAPHY.fontSize.sm,
							fontWeight: "600",
						}}
					>
						Member Profile
					</span>
				</div>
				<div style={{ fontSize: TYPOGRAPHY.fontSize.sm, fontWeight: "600", marginLeft: "32px", color: "#374151" }}>
					{user.memberData?.name || "ไม่มีชื่อ"}
				</div>
				<div style={{ fontSize: TYPOGRAPHY.fontSize.sm, color: "#6b7280", marginLeft: "32px", marginTop: "2px" }}>Member ID: {user.memberData?.id}</div>
				<div
					style={{
						fontSize: TYPOGRAPHY.fontSize.sm,
						color: "#6b7280",
						marginTop: "4px",
						marginLeft: "32px",
						display: "flex",
						alignItems: "center",
						gap: "6px",
					}}
				>
					<span role="img" aria-label="email">
						📧
					</span>
					{user.memberData?.email || user.memberData?.msisdn || "ไม่มีข้อมูลติดต่อ"}
				</div>
			</div>

			{/* Customer Data */}
			{user.customerData ? <CustomerDataSection customerData={user.customerData} searchQuery="" /> : <NoCustomerDataSection />}
		</div>
	</div>
)

export default AddPlanModal
